var ___EXPOSE_LOADER_IMPORT___ = require("-!../../babel-loader/lib/index.js??ruleSet[1].rules[3].oneOf[4]!../../source-map-loader/dist/cjs.js!./index.js");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../../expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
if (typeof ___EXPOSE_LOADER_GLOBAL_THIS___["DynamicAssets"] === 'undefined') ___EXPOSE_LOADER_GLOBAL_THIS___["DynamicAssets"] = ___EXPOSE_LOADER_IMPORT___;
module.exports = ___EXPOSE_LOADER_IMPORT___;
